<template>
  <v-sheet v-if="week_ext_data">
    <v-row>
      <template v-for="(day, index) in week_generated" :key="day">
        <v-fade-transition>
          <v-col v-if="is_not_hidden(index)" :class="{'current_weekday' : is_today(day)}" style="padding: 4px">
            <Day__WP_InfoCard :index="index" :day="day" />
          </v-col>
        </v-fade-transition>
      </template>
    </v-row>
  </v-sheet>
  <v-sheet v-else>
    <Loader />
  </v-sheet>
</template>

<script>
import { CurrentPeriod } from "@/store/wp_planner/main.store";
import moment from "moment";
import { HideWeekends } from "@/store/wp_planner/settings.store"
import { Reg_Documents } from "@/store/wp_planner/documents/registered.store"
import { WeekDura, WeekGenerated} from "@/store/wp_planner/specialists.store"
import Day__WP_InfoCard from "@/components/wp_planner/calendar/day.calendar.vue"
import { EventsList } from "@/store/wp_planner/events.store";
import Loader from "@/components/Different/Loader.vue";
import { TokenGUIDStore } from "@/store/global/SessionStore";

export default {
  name: "Calendar__WP_View",
  components: { Loader, Day__WP_InfoCard },
  data() {
    return {
      value: 0,
      moment: moment,
      drag: false,
      show_evs: false
    }
  },
  methods: {
    is_today(day) {
      return moment(day.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')
    },
    is_full: function (index, day) {
      if (this.week_ext_data && this.week_ext_data[index]) {
        if (day.used === 5) {
          return '_full'
        }
      }
      return ''
    },
    get_day_events: function (day) {
      return this.events.filter(el => {
        if (el && el.date && el.date.desire) {
          return el.date.desire === day
        }
        return false
      })
    },
    is_not_hidden: function (index) {
      if (index < 5) {
        return true
      } else {
        return !this.hidden_weekends
      }
    }
  },
  computed: {
    session_token() {
      return TokenGUIDStore().get()
    },
    events: {
      get() {
        return EventsList().get()
      },
      set(value) {
        EventsList().set(value)
      }
    },
    week_generated() {
      let sd = this.current_period;

      let array = []
      for (let i = 0; i < 7; i++) {
        let date = moment(sd).add(i, 'days').format('YYYY-MM-DD[T]HH:mm:ss')
        let used = 0

        this.get_day_events(date).map(el => {
          used += parseFloat(el.duration)
        })

        array.push({
          date: date,
          observer1: null,
          observer2: null,
          used: used.toFixed(2),
          is_full: used >= this.week_ext_data[i]
        })
      }

      WeekGenerated().set(array)
      return array
    },
    week_ext_data: {
      get() {
        return WeekDura().get()
      },
      set(value) {
        WeekDura().set(value)
      }
    },
    docs__registered: {
      get() {
        return Reg_Documents().get()
      },
      set(value) {
        Reg_Documents().set(value)
      }
    },
    current_period: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    },
    hidden_weekends: {
      get() {
        return HideWeekends().get()
      },
      set(v) {
        HideWeekends().set(v)
      }
    }
  }
}
</script>

<style>
.current_weekday {
  border: 2px dotted #8bc34a;
  background: rgba(139, 195, 74, 0.34);
  border-radius: 10px;
}
</style>
